var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"display":"block","width":"100vw","min-height":"100vh"},attrs:{"id":"ytplayer","src":_vm.url,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }